// hooks/features/chatbot/use-chatbot.ts
import { useGetChatbotConfig } from "@/src/services/api/chatbot/chatbot.hooks";

/**
 * Reads the org's chatbot wiring. The app no longer provisions any of it.
 *
 * One agent PER ORG, provisioned out-of-band (Blocks console), each with that
 * org's knowledge-base folder attached. The app only connects to what already
 * exists: `widgetId` opens the chat session, `kbFolderId` is where wiki content
 * is ingested.
 *
 * Why per-org and not one shared agent: retrieval scope is a property of the
 * AGENT — `POST /api/agents/update-ai-configurations` takes `folder_ids`, and a
 * chat session is opened with nothing but `widget_id` (`POST
 * /api/conversation/initiate`). There is no per-session, per-user or per-org KB
 * filter anywhere in the chat path, so a single agent holding every org's folder
 * would let any user retrieve across every org. Sharing a folder with the
 * `Default` org via `POST /api/org-sharing/assign` does NOT cause that leak —
 * org-sharing is a management ACL over `agent | kb | kb-folder | tool | …`, and
 * is not consulted at retrieval time.
 *
 * Setup/teardown used to live here (`agents/create`, `kb/folder/create`,
 * `agents/update-ai-configurations`, plus the matching deletes) driven by an
 * Enable/Disable button on the dashboard. Creating a tenant-scoped agent from a
 * client button is what forced the one-agent-per-click model in the first place;
 * provisioning is now an admin task and the button is gone.
 */
export const useChatbot = () => {
  const { data: chatbotConfig, isPending: isConfigLoading } =
    useGetChatbotConfig();

  return { chatbotConfig, isConfigLoading };
};
